import { render, staticRenderFns } from "./PersonTwoWorkingRetired.vue?vue&type=template&id=45aeaecc&"
import script from "./PersonTwoWorkingRetired.vue?vue&type=script&lang=js&"
export * from "./PersonTwoWorkingRetired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports